import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

export const specialRequestsSectionPath = "/special-requests";

export type SpecialRequestsMainTab = "approved" | "received";
export type SpecialRequestsReceivedTab = "submitted" | "rejected";

export interface SpecialRequestsUrlQueryParams {
  tab?: SpecialRequestsMainTab;
  receivedTab?: SpecialRequestsReceivedTab;
}

export const specialRequestsListPath = specialRequestsSectionPath;

export const specialRequestsListUrl = (params?: SpecialRequestsUrlQueryParams) => {
  if (!params) {
    return specialRequestsListPath;
  }

  return urlJoin(specialRequestsListPath, `?${stringifyQs(params)}`);
};
